import { faqData } from '@/mocks/homeData';

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {faqData.title}
        </h2>
        <div className="space-y-3 md:space-y-4">
          {faqData.items.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-7">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}